import {Dialog, DialogActions, DialogActionsProps, Divider, styled} from "@mui/material";
import React from "react";

export const BarekamDialog = styled(Dialog)(() => {
    return {

    }
});

export const BarekamMobileDialog = styled(BarekamDialog)(() => {
    return {
        '& .MuiDialog-paper': {
            width: '100%',
            maxWidth: 'unset',
            margin: 'unset'
        }
    }
});

export const DialogButtonContainer = styled("div")(() => {
    return {
        display: 'flex',
        justifyContent: 'right',
        width: '100%',

        '& .MuiButtonBase-root' : {
            margin: '1rem',
            marginLeft: '0rem'
        },
        '&.MuiDialogActions-root': {
            padding: 'unset'
        }
    }
});

export const DialogActionsContainer = styled((props: DialogActionsProps) =>
    <>
        <Divider style={{width:'100%'}}/>
        <DialogActions {...props}/>
    </>
)(() => {
    return {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',

        '& .MuiButtonBase-root' : {
            marginTop: '1rem',
            marginBottom: '1rem',
            marginRight: '1rem',
            marginLeft: '0'
        },
        '&.MuiDialogActions-root': {
            padding: 'unset',
            paddingLeft: '1rem',
        }
    }
});